import { render, staticRenderFns } from "./QuestionReward.vue?vue&type=template&id=8efd918c&scoped=true&"
import script from "./QuestionReward.vue?vue&type=script&lang=js&"
export * from "./QuestionReward.vue?vue&type=script&lang=js&"
import style0 from "./QuestionReward.vue?vue&type=style&index=0&id=8efd918c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efd918c",
  null
  
)

export default component.exports